import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=26203d87&scoped=true&"
import script from "./ServicesPage.vue?vue&type=script&lang=js&"
export * from "./ServicesPage.vue?vue&type=script&lang=js&"
import style0 from "./ServicesPage.vue?vue&type=style&index=0&id=26203d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26203d87",
  null
  
)

export default component.exports